import SystemValueList from "../../../../components/SystemValue/SystemValueList";

const COLUMNS = [
  { header: "Source Language", render: (p) => p.sourceLanguage?.name || "—" },
  { header: "Target Language", render: (p) => p.targetLanguage?.name || "—" },
];

const LanguagePairList = ({ pairs, onEdit, onDelete }) => (
  <SystemValueList
    items={pairs}
    columns={COLUMNS}
    onEdit={onEdit}
    onDelete={onDelete}
    emptyMessage="No language pairs added yet."
    minWidth={600}
  />
);

export default LanguagePairList;
